import { TreatmentPlanDto } from "../../../../core/models/http/treatment/treatment-plans/treatment-plan-dto";
import {
  IMaxxOptimizerQueryDto,
  OptimizerStep,
} from "../../../../core/models/http/treatment/treatment-plans/optimizer-dto";
import { TreatmentPlan } from "./models/treatment-plan";

export const getTreatmentPlanName = (treatmentPlan: TreatmentPlanDto): string =>
  treatmentPlan.Name !== null
    ? treatmentPlan.Name
    : `${treatmentPlan.TreatmentFee.Description} ${treatmentPlan.TreatmentOptionFee.Description}`;

export const mapTreatmentPlan = (
  tp: TreatmentPlanDto,
  sortOrder: number,
  optimizerStep?: OptimizerStep
): TreatmentPlan => {
  return {
    id: tp.TreatmentPlanId,
    isOptimizable: tp.IsOptimizable,
    imaxxEvaluationResult: tp.TreatmentOptimizer?.ImaxxEvaluationResult,
    optimizerStep:
      optimizerStep ||
      tp.TreatmentOptimizer?.ImaxxEvaluationResult.IMaxxStatus.OptimizerStep,
    maxDuration: tp.MaxDuration,
    minDuration: tp.MinDuration,
    name: getTreatmentPlanName(tp),
    offerAcceledent: tp.OfferAcceledent,
    sortOrder,
  };
};

export const mapOptimizedTreatmentPlan = (
  otp: IMaxxOptimizerQueryDto,
  sortOrder: number,
  optimizerStep?: OptimizerStep
): TreatmentPlan => {
  return {
    id: otp.TreatmentPlan.TreatmentPlanId,
    imaxxEvaluationResult: otp.ImaxxEvaluationResult || null,
    optimizerStep:
      optimizerStep || otp.ImaxxEvaluationResult.IMaxxStatus.OptimizerStep,
    isOptimizable: otp.TreatmentPlan.IsOptimizable,
    maxDuration: otp.TreatmentPlan.MaxDuration,
    minDuration: otp.TreatmentPlan.MinDuration,
    name: getTreatmentPlanName(otp.TreatmentPlan),
    offerAcceledent: otp.TreatmentPlan.OfferAcceledent,
    sortOrder,
  };
};
